
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    title: {
      type: String,
      required: false,
    },
    enableOverflow: {
      type: Boolean,
      default: true,
    },
  },

  setup() {
    return {};
  },
});
